import { useEffect, useState } from "react";
import "./styles/index.scss";

const RangeSlider = ({ min, max, current, unit, hasRange = true }) => {
  const [isInvalid, setIsInvalid] = useState(false);
  const [currentDisplacement, setCurrentDisplacement] = useState(50); // Default to the middle
  const [leftDisplacement, setLeftDisplacement] = useState(0);
  const [rightDisplacement, setRightDisplacement] = useState(0);

  useEffect(() => {
    if (!hasRange) {
      // No range to plot against: keep the thumb centered for visual balance
      // instead of running the min/max-based displacement math below.
      setCurrentDisplacement(50);
      setIsInvalid(false);
      setLeftDisplacement(0);
      setRightDisplacement(0);
      return;
    }

    const minValue = min ?? (max ? current / 2 : current - current / 2);
    const maxValue = max ?? (min ? current * 2 : current + current / 2);
    const maxWidth = maxValue - minValue;
    let leftDispl = null;
    let rightDispl = null;
    let currDispl;

    if (current <= minValue) {
      currDispl = 0;

      if (!max) {
        // Expand global range to include current value below min
        const globalRange = maxValue - current;
        const minPositionInRange = (minValue - current) / globalRange * 100;
        leftDispl = minPositionInRange;
      } else {
        const fullRange = max - current;
        const excess = min - current;
        leftDispl = (excess / fullRange) * 100;
      }
    } else if (current >= maxValue) {
      currDispl = 100;

      if (!min) {
        // Expand global range to include current value above max
        const globalRange = current - minValue;
        const maxPositionInRange = (current - maxValue) / globalRange * 100;
        rightDispl = maxPositionInRange;
      } else {
        const fullRange = current - min;
        const excess = current - max;
        rightDispl = (excess / fullRange) * 100;
      }
    } else {
      currDispl = ((current - minValue) * 100) / maxWidth;
    }

    setCurrentDisplacement(currDispl);
    setIsInvalid(current < minValue || current > maxValue);

    setLeftDisplacement(leftDispl || 0);
    setRightDisplacement(rightDispl || 0);
  }, [min, max, current, hasRange]);

  return (
    <div className={`slider-range`}>
      <div
        className="range"
        style={{
          left: `${leftDisplacement}%`,
          width: `${100 - leftDisplacement - rightDisplacement}%`,
        }}
      />
      <div
        className={`current-value ${isInvalid ? "invalid" : ""}`}
        style={{ left: `calc(${currentDisplacement}% - 5px)` }}
      >
        {`${current} ${unit}`}
      </div>
      <div
        className={`current-point ${isInvalid ? "invalid" : ""}`}
        style={{ left: `${currentDisplacement}%` }}
      />
      {hasRange && (
        <div className="min-max" style={{ width: "100%", position: "relative" }}>
          <span
            className="min"
            style={{ position: "absolute", left: `${leftDisplacement}%` }}
          >
            {min ?? "-"}
          </span>
          <span className="max" style={{ position: "absolute", right: `${rightDisplacement}%` }}>
            {max ?? "-"}
          </span>
        </div>
      )}
    </div>
  );
};

export default RangeSlider;
